import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import { SharedService } from "src/app/services/shared.service";
import * as moment from "moment";

@Component({
  selector: "app-samplecollectioncenters",
  templateUrl: "./samplecollectioncenters.component.html",
  styleUrls: ["./samplecollectioncenters.component.scss"],
})
export class SamplecollectioncentersComponent implements OnInit {
  apiUrl: string;
  addCenterForm: FormGroup;
  addEmployeeForm: FormGroup;
  searchForm: FormGroup;
  dtOptions: any = {};
  submitted = false;
  collectionCenterTab: boolean = true;
  employeesTab: boolean;
  collectionCenters: any = {};

  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};

  center: any;
  centerSingleResponse: any;
  updatecenterId: any;
  isDisabled: boolean = false;
  isEdit: boolean = false;
  workingDays: any[] = [];

  applicationId: any;
  private_laboratory_appId: any;

  errorMsg: any = "";

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    public shared: SharedService
  ) {}

  ngOnInit(searchObj = null) {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem("application_id");
    this.private_laboratory_appId = environment.APP_ID_PRIVATE_LABORATORY;
    this.sess.confirmUser(
      this.applicationId,
      this.private_laboratory_appId,
      "Private Laboratory"
    );

    if (searchObj == null || searchObj == "") {
      this.collectionCenters = "";
      this.initialiseForm();
      this.setWorkingDaysAndHoursValidators();
      this.initTable();
      console.log("searchObj is null");
    } else {
      this.collectionCenters = "";
      console.log("searchObj is not null");
    }

    //this.initialiseForm();
    //this.initTable();
    //this.getCollectionCenters();

    /* Pagination Start */
    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };

    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );

    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );

    // this.shared.getLabs();
    this.shared.getLgaCodes();
  }

  initialiseForm() {
    this.addEmployeeForm = this.formBuilder.group({
      emailAddress: [
        "",
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      confirmPassword: ["", [Validators.required]],
      name: ["", [Validators.required, Validators.maxLength(45)]],
      password: ["", [Validators.required]],
      collectionCenter: ["", [Validators.required]],
    });

    this.addCenterForm = this.formBuilder.group(
      {
        name: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.maxLength(45),
          ],
        ],
        location: ["", [Validators.required, Validators.maxLength(45)]],
        emailAddress: [
          "",
          [
            Validators.required,
            Validators.maxLength(45),
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
          ],
        ],
        phoneNumber: [
          "",
          [
            Validators.required,
            Validators.pattern(/^[0][1-9]\d{9}$|^[1-9]\d{9}$/),
            Validators.minLength(11),
            Validators.maxLength(11),
          ],
        ],
        amount: ["", [Validators.required, Validators.min(1)]],
        //   lab: ["", [Validators.required]],
        lga_code: ["", [Validators.required]],
        status: ["", [Validators.required]],
        durationOfTest: [
          "",
          [Validators.required, Validators.min(1), Validators.max(1440)],
        ],
        numberOfTestAttendant: [
          "",
          [Validators.required, Validators.min(1), Validators.max(1440)],
        ],
        lunchTimeFrom: ["", [Validators.required]],
        lunchTimeTo: ["", [Validators.required]],

        // START SUB GROUP

        //sunday
        sundayHours: this.formBuilder.group(
          {
            sunday: [false, []],
            sunday_open_time: ["", []],
            sunday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "sunday_open_time",
              "sunday_close_time"
            ),
          }
        ),

        //monday
        mondayHours: this.formBuilder.group(
          {
            monday: [false, []],
            monday_open_time: ["", []],
            monday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "monday_open_time",
              "monday_close_time"
            ),
          }
        ),

        //tuesday
        tuesdayHours: this.formBuilder.group(
          {
            tuesday: [false, []],
            tuesday_open_time: ["", []],
            tuesday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "tuesday_open_time",
              "tuesday_close_time"
            ),
          }
        ),

        //wednesday
        wednesdayHours: this.formBuilder.group(
          {
            wednesday: [false, []],
            wednesday_open_time: ["", []],
            wednesday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "wednesday_open_time",
              "wednesday_close_time"
            ),
          }
        ),

        //thursday
        thursdayHours: this.formBuilder.group(
          {
            thursday: [false, []],
            thursday_open_time: ["", []],
            thursday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "thursday_open_time",
              "thursday_close_time"
            ),
          }
        ),

        //friday
        fridayHours: this.formBuilder.group(
          {
            friday: [false, []],
            friday_open_time: ["", []],
            friday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "friday_open_time",
              "friday_close_time"
            ),
          }
        ),
        //saturday
        saturdayHours: this.formBuilder.group(
          {
            saturday: [false, []],
            saturday_open_time: ["", []],
            saturday_close_time: ["", []],
          },
          {
            validator: this.utility.mustNotEqualNorLessThan(
              "saturday_open_time",
              "saturday_close_time"
            ),
          }
        ),
        //END SUB GROUP

        // sunday: [false, []],
        // sunday_open_time: ["", []],
        // sunday_close_time: ["", []],

        // monday: [false, []],
        // monday_open_time: ["", []],
        // monday_close_time: ["", []],

        // tuesday: [false, []],
        // tuesday_open_time: ["", []],
        // tuesday_close_time: ["", []],

        // wednesday: [false, []],
        // wednesday_open_time: ["", []],
        // wednesday_close_time: ["", []],

        // thursday: [false, []],
        // thursday_open_time: ["", []],
        // thursday_close_time: ["", []],

        // friday: [false, []],
        // friday_open_time: ["", []],
        // friday_close_time: ["", []],

        // saturday: [false, []],
        // saturday_open_time: ["", []],
        // saturday_close_time: ["", []],
      },
      {
        validator: this.utility.mustNotEqualNorLessThan(
          "lunchTimeFrom",
          "lunchTimeTo"
        ),
      }
    );

    this.searchForm = this.formBuilder.group({
      center_name: [""],
      center_phone: [""],
      center_email: [""],
    });
  }

  initTable() {
    this.dtOptions = {
      paging: false,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: false,
      processing: false,
      ordering: false,
      info: false,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  onSubmitCenter(formData) {
    this.submitted = true;

    if (this.addCenterForm.invalid) {
      return;
    }

    if (this.minRequiredCheckboxNotChecked()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please set at least one work days and working hours.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }

    // if (this.mustNotEqualNorLessThan()) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     html: this.errorMsg,
    //     showConfirmButton: true,
    //     timer: 15000,
    //   });
    //   return;
    // }

    var requestObj = {
      name: formData.name,
      email: formData.emailAddress,
      address: formData.location,
      phone: formData.phoneNumber,
      amount: formData.amount,
      test_duration: formData.durationOfTest,
      working_days: this.getWorkingDays(formData),
      lunch_from: formData.lunchTimeFrom,
      lunch_to: formData.lunchTimeTo,
      //   lab_id: formData.lab,a
      lga_code_id: formData.lga_code,
      active: formData.status == "Active" ? true : false,
      test_attendants: formData.numberOfTestAttendant,
    };

    this.apiUrl = environment.AUTHAPIURL + "collection-center/add";
    if (this.isEdit) {
      requestObj["id"] = this.updatecenterId;
      this.apiUrl = environment.AUTHAPIURL + "collection-center/update";
    }

    console.log(requestObj);

    this.spinnerService.show();

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        //console.log("registerApiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });

          //   this.getCollectionCenters(
          //     this.config.itemsPerPage,
          //     this.config.currentPage
          //   );

          this.ngOnInit();
          this.utility.closeAllModals();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: this.shared.getErrorMessage(data),
            // text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  getWorkingDays(formData) {
    let working_days = {};

    if (formData.sundayHours.sunday) {
      working_days["sunday"] = {
        opening_time: formData.sundayHours.sunday_open_time,
        closing: formData.sundayHours.sunday_close_time,
      };
    }
    if (formData.mondayHours.monday) {
      working_days["monday"] = {
        opening_time: formData.mondayHours.monday_open_time,
        closing: formData.mondayHours.monday_close_time,
      };
    }
    if (formData.tuesdayHours.tuesday) {
      working_days["tuesday"] = {
        opening_time: formData.tuesdayHours.tuesday_open_time,
        closing: formData.tuesdayHours.tuesday_close_time,
      };
    }
    if (formData.wednesdayHours.wednesday) {
      working_days["wednesday"] = {
        opening_time: formData.wednesdayHours.wednesday_open_time,
        closing: formData.wednesdayHours.wednesday_close_time,
      };
    }
    if (formData.thursdayHours.thursday) {
      working_days["thursday"] = {
        opening_time: formData.thursdayHours.thursday_open_time,
        closing: formData.thursdayHours.thursday_close_time,
      };
    }
    if (formData.fridayHours.friday) {
      working_days["friday"] = {
        opening_time: formData.fridayHours.friday_open_time,
        closing: formData.fridayHours.friday_close_time,
      };
    }
    if (formData.saturdayHours.saturday) {
      working_days["saturday"] = {
        opening_time: formData.saturdayHours.saturday_open_time,
        closing: formData.saturdayHours.saturday_close_time,
      };
    }

    return working_days;
  }

  onSubmitEmployee(formData) {
    this.submitted = true;

    if (this.addEmployeeForm.invalid) {
      return;
    }

    var requestObj = {
      employee_name: formData.name,
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirmPassword,
      collection_center: formData.collectionCenter,
    };

    // console.log('registerRequest: ', requestObj);
    this.apiUrl = environment.AUTHAPIURL + "employee";

    this.http.post<any>(this.apiUrl, requestObj).subscribe((data) => {
      // console.log('registerApiResponse: ', data);
      this.spinnerService.hide();

      if (data.status == true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          html: this.shared.getErrorMessage(data),
          // text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    });
  }

  showCenters() {
    this.collectionCenterTab = true;
    this.employeesTab = false;
  }

  showEmployees() {
    this.collectionCenterTab = false;
    this.employeesTab = true;
  }

  viewAddCenter(modal) {
    this.utility.showModal(modal);
  }
  viewAddEmployee(modal) {
    this.utility.showModal(modal);
  }

  getCollectionCenters(perpage, pageno) {
    // var requestObj = {
    // 					application_id: localStorage.getItem('application_id'),
    // 					role_id: localStorage.getItem('role_id'),
    // 	  			};

    this.spinnerService.show();

    //this.apiUrl = environment.AUTHAPIURL + "collection-center-list";
    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center/list?page=` + pageno;

    this.searchObject["page_no"] = pageno;
    this.searchObject["per_page"] = perpage;
    this.searchObject["application_id"] =
      localStorage.getItem("application_id");
    this.searchObject["role_id"] = localStorage.getItem("role_id");

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        console.log(data);
        if (data.status == true) {
          this.collectionCenters = data.response.data;
          this.config.totalItems = data.response.total;
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  pageChange(newPage: number) {
    this.collectionCenters = "";
    this.router.navigate(["/collectioncenters"], {
      queryParams: { page: newPage },
    });
    this.getCollectionCenters(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.collectionCenters = "";
    this.router.navigate(["/collectioncenters"]);
    this.getCollectionCenters(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      name: formAllData.center_name,
      phone: formAllData.center_phone,
      email: formAllData.center_email,
    };

    console.log("searchFormData: ", this.searchObject);
    this.collectionCenters = "";
    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }

  clearSearch() {
    this.collectionCenters = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }

  minRequiredCheckboxNotChecked(minRequired = 1) {
    let checked = 0;

    Object.keys({
      sunday: "",
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
    }).forEach((key) => {
      if (this.addCenterForm.get(key + "Hours").get(key).value === true) {
        checked++;
      }
    });

    // Object.keys(this.addCenterForm.controls).forEach((key) => {
    //   const control = this.addCenterForm.controls[key];
    //   if (control.value === true) {
    //     checked++;
    //   }
    // });

    return checked < minRequired;
  }

  mustNotEqualNorLessThan() {
    let checked = 0;
    this.errorMsg = "";

    Object.keys(this.addCenterForm.controls).forEach((key) => {
      const control = this.addCenterForm.controls[key];
      if (control.value === true) {
        const open_time = this.addCenterForm.get(key + "_open_time").value;
        const close_time = this.addCenterForm.get(key + "_close_time").value;

        const dateFormat = "YYYY-MM-DD";
        let now = moment(new Date()).format(dateFormat);

        const timeFrom = now + " " + open_time;
        const timeTo = now + " " + close_time;

        const timeFromMoment = moment(timeFrom);
        const timeToMoment = moment(timeTo);

        let duration = moment.duration(timeToMoment.diff(timeFromMoment));
        let minutes = duration.asMinutes();
        // let hours = duration.asHours();

        if (minutes < 15) {
          this.errorMsg +=
            key +
            " Close Time can not be less than 15 minutes nor less than or equals the Open Time. <br />";
          checked++;
        }
      }
    });

    return checked > 0;
  }

  setWorkingDaysAndHoursValidators() {
    const sunday_open_time = this.addCenterForm
      .get("sundayHours")
      .get("sunday_open_time");
    const sunday_close_time = this.addCenterForm
      .get("sundayHours")
      .get("sunday_close_time");
    const monday_open_time = this.addCenterForm
      .get("mondayHours")
      .get("monday_open_time");
    const monday_close_time = this.addCenterForm
      .get("mondayHours")
      .get("monday_close_time");
    const tuesday_open_time = this.addCenterForm
      .get("tuesdayHours")
      .get("tuesday_open_time");
    const tuesday_close_time = this.addCenterForm
      .get("tuesdayHours")
      .get("tuesday_close_time");
    const wednesday_open_time = this.addCenterForm
      .get("wednesdayHours")
      .get("wednesday_open_time");
    const wednesday_close_time = this.addCenterForm
      .get("wednesdayHours")
      .get("wednesday_close_time");
    const thursday_open_time = this.addCenterForm
      .get("thursdayHours")
      .get("thursday_open_time");
    const thursday_close_time = this.addCenterForm
      .get("thursdayHours")
      .get("thursday_close_time");
    const friday_open_time = this.addCenterForm
      .get("fridayHours")
      .get("friday_open_time");
    const friday_close_time = this.addCenterForm
      .get("fridayHours")
      .get("friday_close_time");
    const saturday_open_time = this.addCenterForm
      .get("saturdayHours")
      .get("saturday_open_time");
    const saturday_close_time = this.addCenterForm
      .get("saturdayHours")
      .get("saturday_close_time");

    // this.utility.MustNotEqual("sunday_open_time", "sunday_close_time")
    this.addCenterForm
      .get("sundayHours")
      .get("sunday")
      .valueChanges.subscribe((sunday) => {
        if (sunday === true) {
          sunday_open_time.setValidators([Validators.required]);
          sunday_close_time.setValidators([Validators.required]);
        }

        if (sunday === false) {
          sunday_open_time.setValidators(null);
          sunday_close_time.setValidators(null);
        }

        sunday_open_time.updateValueAndValidity();
        sunday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("mondayHours")
      .get("monday")
      .valueChanges.subscribe((monday) => {
        if (monday === true) {
          monday_open_time.setValidators([Validators.required]);
          monday_close_time.setValidators([Validators.required]);
        }

        if (monday === false) {
          monday_open_time.setValidators(null);
          monday_close_time.setValidators(null);
        }

        monday_open_time.updateValueAndValidity();
        monday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("tuesdayHours")
      .get("tuesday")
      .valueChanges.subscribe((tuesday) => {
        if (tuesday === true) {
          tuesday_open_time.setValidators([Validators.required]);
          tuesday_close_time.setValidators([Validators.required]);
        }

        if (tuesday === false) {
          tuesday_open_time.setValidators(null);
          tuesday_close_time.setValidators(null);
        }

        tuesday_open_time.updateValueAndValidity();
        tuesday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("wednesdayHours")
      .get("wednesday")
      .valueChanges.subscribe((wednesday) => {
        if (wednesday === true) {
          wednesday_open_time.setValidators([Validators.required]);
          wednesday_close_time.setValidators([Validators.required]);
        }

        if (wednesday === false) {
          wednesday_open_time.setValidators(null);
          wednesday_close_time.setValidators(null);
        }

        wednesday_open_time.updateValueAndValidity();
        wednesday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("thursdayHours")
      .get("thursday")
      .valueChanges.subscribe((thursday) => {
        if (thursday === true) {
          thursday_open_time.setValidators([Validators.required]);
          thursday_close_time.setValidators([Validators.required]);
        }

        if (thursday === false) {
          thursday_open_time.setValidators(null);
          thursday_close_time.setValidators(null);
        }

        thursday_open_time.updateValueAndValidity();
        thursday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("fridayHours")
      .get("friday")
      .valueChanges.subscribe((friday) => {
        if (friday === true) {
          friday_open_time.setValidators([Validators.required]);
          friday_close_time.setValidators([Validators.required]);
        }

        if (friday === false) {
          friday_open_time.setValidators(null);
          friday_close_time.setValidators(null);
        }

        friday_open_time.updateValueAndValidity();
        friday_close_time.updateValueAndValidity();
      });

    this.addCenterForm
      .get("saturdayHours")
      .get("saturday")
      .valueChanges.subscribe((saturday) => {
        if (saturday === true) {
          saturday_open_time.setValidators([Validators.required]);
          saturday_close_time.setValidators([Validators.required]);
        }

        if (saturday === false) {
          saturday_open_time.setValidators(null);
          saturday_close_time.setValidators(null);
        }

        saturday_open_time.updateValueAndValidity();
        saturday_close_time.updateValueAndValidity();
      });
  }

  showEditCenter(center, modal) {
    this.spinnerService.show();
    this.submitted = false;
    this.isDisabled = true;
    this.center = center;
    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center/` + this.center.id;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .get<any>(this.apiUrl, { headers: reqHeader })
      .subscribe((data) => {
        console.log("Single Lab User Details: ", data);
        this.centerSingleResponse = data.response;
        this.spinnerService.hide();
        console.log(this.centerSingleResponse);

        this.addCenterForm.controls["name"].setValue(
          this.centerSingleResponse.name
        );
        this.addCenterForm.controls["location"].setValue(
          this.centerSingleResponse.address
        );
        this.addCenterForm.controls["emailAddress"].setValue(
          this.centerSingleResponse.email
        );
        this.addCenterForm.controls["phoneNumber"].setValue(
          this.centerSingleResponse.phone
        );
        this.addCenterForm.controls["amount"].setValue(
          this.centerSingleResponse.amount
        );
        this.addCenterForm.controls["lga_code"].setValue(
          this.centerSingleResponse.lga_code_id
        );
        this.addCenterForm.controls["status"].setValue(
          this.centerSingleResponse.active ? "Active" : "Inactive"
        );
        this.addCenterForm.controls["durationOfTest"].setValue(
          this.centerSingleResponse.test_duration
        );
        this.addCenterForm.controls["numberOfTestAttendant"].setValue(
          this.centerSingleResponse.test_attendants
        );

        this.addCenterForm.controls["lunchTimeFrom"].setValue(
          this.centerSingleResponse.lunch_from
        );
        this.addCenterForm.controls["lunchTimeTo"].setValue(
          this.centerSingleResponse.lunch_to
        );

        //Set days & working hours
        // if (this.centerSingleResponse.working_days != null) {
        //   Object.keys(this.centerSingleResponse.working_days).forEach((key) => {
        //     if (this.addCenterForm.controls.hasOwnProperty(key)) {
        //       this.addCenterForm.controls[key].setValue(true);
        //       this.addCenterForm.controls[key + "_open_time"].setValue(
        //         this.centerSingleResponse.working_days[key]["opening_time"]
        //       );
        //       this.addCenterForm.controls[key + "_close_time"].setValue(
        //         this.centerSingleResponse.working_days[key]["closing"]
        //       );
        //     }
        //   });
        // }

        if (this.centerSingleResponse.working_days != null) {
          Object.keys(this.centerSingleResponse.working_days).forEach((key) => {
            if (
              this.addCenterForm
                .get(key + "Hours")
                ["controls"].hasOwnProperty(key)
            ) {
              this.addCenterForm
                .get(key + "Hours")
                .get(key)
                .setValue(true);
              this.addCenterForm
                .get(key + "Hours")
                .get(key + "_open_time")
                .setValue(
                  this.centerSingleResponse.working_days[key]["opening_time"]
                );
              this.addCenterForm
                .get(key + "Hours")
                .get(key + "_close_time")
                .setValue(
                  this.centerSingleResponse.working_days[key]["closing"]
                );
            }
          });
        }
        //End

        this.updatecenterId = this.center.id;
        this.utility.openModal(modal);
      });
  }

  showCenterDetails(center, modal) {
    this.spinnerService.show();
    this.submitted = false;
    // this.isDisabled = true;
    this.center = center;
    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center/` + this.center.id;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .get<any>(this.apiUrl, { headers: reqHeader })
      .subscribe((data) => {
        // console.log("Single center Details: ", data);
        this.centerSingleResponse = data.response;
        //Start get working days
        this.workingDays = [];
        if (this.centerSingleResponse.working_days != null) {
          Object.keys(this.centerSingleResponse.working_days).forEach((key) => {
            this.workingDays.push({
              day: key,
              open: this.centerSingleResponse.working_days[key]["opening_time"],
              close: this.centerSingleResponse.working_days[key]["closing"],
            });
          });
        }
        //End
        this.spinnerService.hide();
        this.utility.openModal(modal);
      });
  }
}
